// extracted by mini-css-extract-plugin
export default {"row":"row--MQLEqDb8F3EJhUaAj4Mf","label":"label--NMn8haXENXGHZIFdZfkc","value":"value--u7CuI8sveWBHJaXG1sLn","asterix":"asterix--VeI3mTunJ6aFmtjeBm9B"};